/**
 * FIEP hero slideshow. Native web component.
 * Reads `data-autoplay` (ms) to enable autoplay.
 */
class FiepHero extends HTMLElement {
  constructor() {
    super();
    /** @type {HTMLElement[]} */
    this.slides = [];
    /** @type {HTMLElement[]} */
    this.dots = [];
    this.index = 0;
    this.timer = 0;
    this.interval = 0;
    this.onPrev = this.onPrev.bind(this);
    this.onNext = this.onNext.bind(this);
    this.onDotClick = this.onDotClick.bind(this);
    this.onVisibility = this.onVisibility.bind(this);
  }

  connectedCallback() {
    this.slides = Array.from(this.querySelectorAll('[data-fiep-slide]'));
    if (this.slides.length === 0) return;

    this.dots = Array.from(this.querySelectorAll('[data-fiep-dot]'));
    this.slides[0].classList.add('is-active');

    const prev = this.querySelector('[data-fiep-prev]');
    const next = this.querySelector('[data-fiep-next]');
    if (prev) prev.addEventListener('click', this.onPrev);
    if (next) next.addEventListener('click', this.onNext);
    for (const dot of this.dots) dot.addEventListener('click', this.onDotClick);

    const autoplay = parseInt(this.dataset.autoplay || '0', 10);
    if (autoplay > 0 && this.slides.length > 1) {
      this.interval = autoplay;
      this.start();
      document.addEventListener('visibilitychange', this.onVisibility);
    }
  }

  disconnectedCallback() {
    this.stop();
    document.removeEventListener('visibilitychange', this.onVisibility);
    const prev = this.querySelector('[data-fiep-prev]');
    const next = this.querySelector('[data-fiep-next]');
    if (prev) prev.removeEventListener('click', this.onPrev);
    if (next) next.removeEventListener('click', this.onNext);
    for (const dot of this.dots) dot.removeEventListener('click', this.onDotClick);
  }

  start() {
    if (!this.interval) return;
    this.stop();
    this.timer = window.setInterval(() => this.go(this.index + 1), this.interval);
  }

  stop() {
    if (this.timer) {
      window.clearInterval(this.timer);
      this.timer = 0;
    }
  }

  go(target) {
    if (this.slides.length === 0) return;
    const len = this.slides.length;
    const next = ((target % len) + len) % len;
    this.slides[this.index]?.classList.remove('is-active');
    this.dots[this.index]?.classList.remove('is-active');
    this.index = next;
    this.slides[this.index]?.classList.add('is-active');
    this.dots[this.index]?.classList.add('is-active');
  }

  onPrev() {
    this.go(this.index - 1);
    this.start();
  }

  onNext() {
    this.go(this.index + 1);
    this.start();
  }

  onDotClick(event) {
    const target = event.currentTarget;
    if (!(target instanceof HTMLElement)) return;
    const i = parseInt(target.dataset.fiepDot || '0', 10);
    this.go(i);
    this.start();
  }

  onVisibility() {
    if (document.hidden) this.stop();
    else this.start();
  }
}

if (!customElements.get('fiep-hero')) {
  customElements.define('fiep-hero', FiepHero);
}
